import { StateBounds } from './types';
import { LatLngBoundsExpression } from 'leaflet';

export const MAP_CONFIG = {
  // Default view: Continental United States
  defaultCenter: [39.8283, -98.5795] as [number, number],
  // z=5 is the lowest zoom at which both basemaps render: Earthmover's AGB
  // 100m Flux service rejects tiles below z=5 with HTTP 413 ("too big"),
  // so landing at z=4 with AGB would show a black map. Keeping Stadia at
  // the same z=5 gives parity when users toggle between basemaps.
  defaultZoom: 5,
  minZoom: 4,
  maxZoom: 19,

  // CONUS maximum bounds - prevents panning outside Continental US
  // Format: [[south, west], [north, east]]
  // Adjusted to cut off Mexico and allow proper state centering (especially CA/OR)
  conusBounds: [
    [25.0, -130.0], // Southwest corner (cuts off Mexico, extends west for CA/OR)
    [50.0, -65.0], // Northeast corner (extends to Canadian border, east of Maine)
  ] as [[number, number], [number, number]],

  // Tile-request bbox for expensive thematic basemaps (AGB 100m, etc.) —
  // CONUS plus ~5° of padding on every side. Shows southern Canada and
  // northern Mexico so users read the basemap as global data, not a US-only
  // tileset. Leaflet culls tile requests outside these bounds.
  thematicBasemapBounds: [
    [20.0, -135.0],
    [55.0, -60.0],
  ] as [[number, number], [number, number]],

  // State bounding boxes [southwest, northeast]
  stateBounds: {
    California: [
      [32.5, -124.5],
      [42.1, -114.1],
    ],
    Oregon: [
      [41.9, -124.6],
      [46.3, -116.5],
    ],
    Georgia: [
      [30.4, -85.6],
      [35.0, -80.8],
    ],
    Alabama: [
      [30.2, -88.5],
      [35.0, -84.9],
    ],
  } as StateBounds,

  // Mill location zoom level (shows ~50km radius)
  millZoomLevel: 10,

  // State view zoom level
  stateZoomLevel: 7,

  // Animation duration for map transitions
  animationDuration: 800,
};

// Shared constants for mill markers and supply shed boundaries
export const MILL_ACCENT_COLOR = '#c1f04f';
export const MILL_ICON_SIZE = 40;
export const CLUSTER_ICON_SIZE = 50;

// Helper function to get state bounds as Leaflet LatLngBoundsExpression
export const getStateBounds = (state: string): LatLngBoundsExpression => {
  return MAP_CONFIG.stateBounds[state] as LatLngBoundsExpression;
};
